// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ShoppingCartLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_2933_96)">
                <path
                    d="M8.25004 20.1666C8.7563 20.1666 9.16671 19.7562 9.16671 19.25C9.16671 18.7437 8.7563 18.3333 8.25004 18.3333C7.74378 18.3333 7.33337 18.7437 7.33337 19.25C7.33337 19.7562 7.74378 20.1666 8.25004 20.1666Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.3333 20.1666C18.8396 20.1666 19.25 19.7562 19.25 19.25C19.25 18.7437 18.8396 18.3333 18.3333 18.3333C17.827 18.3333 17.4166 18.7437 17.4166 19.25C17.4166 19.7562 17.827 20.1666 18.3333 20.1666Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M0.916626 0.916687H4.58329L7.03996 13.1909C7.12378 13.6129 7.35337 13.992 7.68854 14.2618C8.02371 14.5316 8.4431 14.6749 8.87329 14.6667H17.7833C18.2135 14.6749 18.6329 14.5316 18.968 14.2618C19.3032 13.992 19.5328 13.6129 19.6166 13.1909L21.0833 5.50002H5.49996"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2933_96">
                    <rect width="24" height="24" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ShoppingCartLineOffset: IconOffset = {
    vertical: 12,
    horizontal: 18,
};

export default React.memo(ShoppingCartLine);
